<template>
  <div class="menu-container">
    <!-- Кнопка назад и заголовок текущей категории -->
    <div class="navigation-header" v-if="breadcrumbs.length > 0">
      <button class="back-button" @click="goBack">
        <i class="pi pi-arrow-left"></i>
      </button>
      <h2 class="current-category">{{ currentCategory }}</h2>
    </div>
    <h2 class="main-title" v-else>Каталог товаров</h2>

    <!-- Текущий уровень меню -->
    <div class="menu-items">
      <div
        v-for="item in currentItems"
        :key="item.id"
        class="menu-item"
        @click="navigateTo(item)"
      >
        <span>{{ item.label }}</span>
        <i class="pi pi-chevron-right" v-if="item.children"></i>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import type { MenuRoot } from '@/types/menuItemTypes'

interface MenuItem {
  id: string;
  label: string;
  children?: MenuItem[];
}

const { fullMenu } = defineProps<{
  fullMenu:MenuRoot
}>()

// Исходная структура меню
const breadcrumbs = ref<MenuItem[]>([]);
const currentItems = ref<MenuItem[]>(fullMenu);

// Вычисляемое свойство для текущей категории
const currentCategory = computed(() => {
  if (breadcrumbs.value.length === 0) return '';
  return breadcrumbs.value[breadcrumbs.value.length - 1].label;
});

const navigateTo = (item: MenuItem) => {
  if (item.children) {
    breadcrumbs.value.push(item);
    currentItems.value = item.children;
  }
};

const goBack = () => {
  if (breadcrumbs.value.length > 0) {
    breadcrumbs.value.pop();
    // Если есть родительские категории - показываем их, иначе полное меню
    currentItems.value = breadcrumbs.value.length > 0
      ? breadcrumbs.value[breadcrumbs.value.length - 1].children || []
      : fullMenu;
  }
};

defineExpose({
  currentCategory
})
</script>

<style scoped>
.menu-container {
  width: 100%;
  border-radius: 8px;
  padding: 15px;
}

.navigation-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 15px;
  padding-bottom: 10px;
}

.back-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 50%;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
}

.back-button:hover {
  background: #f5f5f5;
}

.back-button i {
  color: #555;
  font-size: 14px;
}

.current-category {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.main-title {
  margin: 0 0 15px 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.menu-items {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.menu-item {
  padding: 12px 15px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 6px;
  transition: all 0.2s;
}

.menu-item:hover {
  transform: translateX(2px);
}

.menu-item i {
  color: #888;
  font-size: 14px;
}
</style>